(() => {
  if (window.innerStandardCartLoaded) return;
  window.innerStandardCartLoaded = true;
  const offerTitles = [10, 15, 20].map((percent, index) => `Composez votre sélection — ${percent} % dès ${index + 2} articles`);
  let requestVersion = 0;
  let timer;
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'fr', {style: 'currency', currency: currency || window.Shopify?.currency?.active || 'EUR'}).format(Number(cents || 0) / 100);
  const set = (root, selector, value) => root.querySelectorAll(selector).forEach(el => { if (el.textContent !== value) el.textContent = value; });
  function render(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    const applied = (cart.cart_level_discount_applications || []).some(d => offerTitles.includes(d.title) && Number(d.total_allocated_amount) > 0);
    document.querySelectorAll('[data-is-cart-summary]').forEach(root => {
      const format = cents => money(cents, cart.currency);
      set(root, '[data-is-cart-original]', format(cart.original_total_price));
      set(root, '[data-is-cart-discount]', '−' + format(cart.total_discount));
      root.querySelector('[data-is-cart-discount-row]').hidden = !(cart.total_discount > 0);
      const originalRow = root.querySelector('[data-is-cart-original-row]');
      if (originalRow) originalRow.hidden = !(cart.total_discount > 0);
      const offer = root.querySelector('[data-is-cart-offer]');
      offer.hidden = !(cart.item_count > 0);
      offer.textContent = root.dataset.offer + (applied ? ' ' + root.dataset.applied : '');
      const form = root.closest('form');
      if (form) {
        set(form, '[data-subtotal], [data-checkout-total], [data-is-checkout-total]', format(cart.total_price));
        set(form, '[data-is-cart-count]', String(cart.item_count));
      }
    });
    document.querySelectorAll('[data-is-cart-count]').forEach(el => { el.textContent = String(cart.item_count); });
  }
  async function refresh() {
    if (window.Shopify?.designMode && document.documentElement.classList.contains('amz-cd-editor-preview')) return;
    const version = ++requestVersion;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials: 'same-origin', cache: 'no-store'});
      if (!response.ok) return;
      const cart = await response.json();
      if (version === requestVersion) render(cart);
    } catch (_) {}
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 120); }
  function init() {
    document.querySelectorAll('#CartPageForm [data-products]').forEach(el => {
      if (el.dataset.isCartObserved) return;
      el.dataset.isCartObserved = 'true';
      new MutationObserver(schedule).observe(el, {childList: true, subtree: true});
    });
    schedule();
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-is-cart-page-link]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(link.href);
  }, true);
  document.addEventListener('inner-standard:cart', event => { ++requestVersion; render(event.detail); });
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('ajaxProduct:added', schedule);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('drawer:open', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();